import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../core/auth.service";

@Component({
	selector: "app-profile",
	templateUrl: "./profile.component.html",
	styleUrls: ["./profile.component.scss"]
})
export class ProfileComponent implements OnInit {
	name: string;
	lastName: string;
	loading: boolean = true;

	constructor(private auth: AuthService) {
		this.auth
			.getProfileData()
			.then(data => {
				this.loading = false;
				this.name = data.name;
				this.lastName = data.lastName;
			})
			.catch(err => console.log(err));
	}

	ngOnInit() {}
}



// WEBPACK FOOTER //
// F:/Projects/anoki/src/app/pages/profile/profile.component.ts